module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.dc11b94f.png";